module.exports = __webpack_public_path__ + "img/us-sabor.31013b20.png";